import * as React from 'react';
import { ThemeContext } from 'react-fela';
import { GlobalTheme } from 'types';

export const useTheme: () => GlobalTheme = () => React.useContext(ThemeContext) as GlobalTheme;
